import type { GridColumnInfo } from '../types'
import { getRowId } from './row-id'

export function resolveGridCellElement(
  rootEl: HTMLElement,
  rowId: string,
  column: GridColumnInfo
) {
  const scopes: Element[] = []
  if (column.fixed === 'left') {
    const leftEl = rootEl.querySelector('.z-grid__fixed-left')
    if (leftEl) {
      scopes.push(leftEl)
    }
  } else if (column.fixed === 'right') {
    const rightEl = rootEl.querySelector('.z-grid__fixed-right')
    if (rightEl) {
      scopes.push(rightEl)
    }
  }
  scopes.push(rootEl)

  for (const scope of scopes) {
    const rowEl = scope.querySelector(`[data-row-id="${rowId}"]`)
    const cellEl = rowEl?.querySelector(`[data-column-id="${column.id}"]`)
    if (!cellEl || cellEl.classList.contains('fixed--hidden')) {
      continue
    }
    return cellEl as HTMLElement
  }

  return null
}

export function resolveGridCellInput(
  rootEl: HTMLElement,
  rowId: string,
  column: GridColumnInfo
) {
  const cellEl = resolveGridCellElement(rootEl, rowId, column)
  if (!cellEl) {
    return null
  }
  return (
    (cellEl.querySelector('input:not([type="hidden"]), textarea') as
      | HTMLElement
      | null) ||
    (cellEl.querySelector('.z-input__wrapper') as HTMLElement | null)
  )
}

/** @deprecated 使用 resolveGridCellInput */
export function resolveValidErrorTarget(
  $grid: { bodyRef?: { value?: HTMLElement | null } },
  row: Record<string, unknown>,
  column: GridColumnInfo
) {
  const bodyEl = $grid.bodyRef?.value
  if (!bodyEl) {
    return null
  }
  return resolveGridCellInput(bodyEl, getRowId(row), column)
}
